import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getHoldingSummaryAction, getHoldingDataAction, getHoldingLongAction } from '../../../actions/assetHoldings';
import { getAssestListddlAction } from '../../../actions/assetsddlAction';
import { getAsset } from "../../../actions/assetAction";
import { useNavigate, useParams } from "react-router-dom";
import { getMinMax } from "../../../../config/apiConfig";
import { AgGridReact } from 'ag-grid-react';
import { AssetDropDown } from "../../../UiComponents/AssetDropDown";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import { exportToExcel } from '../../../utils/excelExporter';
import { sbaAxios } from '../../../utils/sbaAxios';
import { UrlPath } from "../../../../config/routeConfig";
import moment from "moment";
import download from '../../Images/download.svg';
import { SBDateRangePicker } from "../../../UiComponents/SBDateRangePicker";
export const Holdings = () => {

  const [Loading, setLoading] = useState(true);
  const [render, setRender] = useState(true);
  const params = useParams();
  const history = useNavigate();
  const dispatch = useDispatch();
  const [HoldingDate, setHoldingDate] = useState();
  const holdingGridRef = useRef();
  const topLongHoldingGridRef = useRef();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1); 
  const [StartDate, setStartDate] = useState(oneMonthAgo);
  const [EndDate, setEndDate] = useState(new Date());
  const getMinMaxValues = async () => {
      !HoldingDate && await sbaAxios({
          url: `${getMinMax}`,
          method: 'get',
      }).then((response) => {
      const MinMaxDateValue = { MinDate: response.MinDate.replace(/\//g, '-'), MaxDate: response.MaxDate.replace(/\//g, '-') }
      setHoldingDate(() => MinMaxDateValue);
      dispatch(getHoldingDataAction(params.Asset, MinMaxDateValue.MinDate, MinMaxDateValue.MaxDate));
    }).catch();
  }
  useEffect(() => {
    dispatch(getAssestListddlAction());
    dispatch(getAsset(params.Asset));
    //top long 
    dispatch(getHoldingLongAction(params.Asset,'12-31-2022',1,2,6));
    //short long
    dispatch(getHoldingLongAction(params.Asset,'12-31-2022',1,2,7));

    HoldingDate && dispatch(getHoldingDataAction(params.Asset, HoldingDate.MinDate, HoldingDate.MaxDate));
  }, [render,params])

  useEffect(() => {
    getMinMaxValues();
  }, []);

  const Gstate = useSelector(state => { return state; }) || {};
  
  useEffect(() => {
    (topLongHoldingData && currentAsset && HoldingDate && HoldingSummary && AssetListDDL) && setLoading(false);
  }, [Gstate]);

  const AssetListDDL = Gstate.assetDDL.assetList || [];

  const currentAsset = Gstate.asset.asset || {};

  const AssetDDChanged = (e) => {
    setRender(!render);
    e.value
      ? history(`${UrlPath.PublicExposure}${e.value.AssetId}`)
      : history(`${UrlPath.PublicExposure}${params.Asset}`);
  };

  let Level = [{ BreadCrumb: "Asset >", Routes: `${UrlPath.Asset}` }];
  Level = Loading
    ? Level
    : [
        ...Level,
        {
          BreadCrumb: `${currentAsset?.AssetName} >`,
          Routes: `${UrlPath.PublicExposure}${params.Asset}`,
        },
        {
          BreadCrumb: `Public Exposure`,
          Routes: `${UrlPath.PrivateExposure}${params.Asset}`,
        },
      ];

  const topLongHoldingData = Gstate.Holdings.topLongHoldings || [];

  const shortLongHoldingData = Gstate.Holdings.shortLongHolding || [];

  const holdingDataISLoading = Gstate.Holdings.isLoading || "";

  const HoldingData = Gstate.Holdings.HoldingData || [];

  const HoldingSummary = Gstate.Holdings.HoldingSummary || [];

  
  const handleDateChange = (e) => {
    if(e)
    {
        const newStartDate = e.value.start !== null ? e.value.start : StartDate;
        const newEndDate = e.value.end !== null ? e.value.end : EndDate;
        setStartDate(newStartDate)
        setEndDate(newEndDate)

    }
  };



  const columnDefs = [
    { field: "CompanyName", headerName: "Company Name", flex: 3 , minWidth:300},
    { field: "Ticker", headerName: "Ticker" },
    { field: "Type", headerName: "Type" },
    { field: "Shares", headerName: "Shares", cellStyle: { textAlign: 'right' },
    valueFormatter: (params) => {
      if (params.value != null) {
        const formattedValue = parseFloat(params.value).toLocaleString();
        return formattedValue;
      } else {
        return '';
      }
    },
    cellStyle: colorCellStyle,
   },
    { field: "ShareChg", headerName: "Share Chg", cellStyle: { textAlign: 'right' },
    valueFormatter: (params) => {
      if (params.value != null) {
        const formattedValue = parseFloat(params.value).toLocaleString();
        return formattedValue;
      } else {
        return '';
      }
    },
    cellStyle: colorCellStyle,
    },

    {
      field: "ShareChgPercent", headerName: "Share Change %", cellStyle: { textAlign: 'right' },
      valueFormatter:percentageFormatter,
      cellStyle: colorCellStyle,
    },
    { field: "MktValue", headerName: "Market Value",
    valueFormatter: currencyFormatter,
    cellStyle: colorCellStyle, minWidth:120,
    },
    { field: "ValueChg", headerName: "Value Change", cellStyle: { textAlign: 'right' },
    valueFormatter: currencyFormatter,
    cellStyle: colorCellStyle,
    },
    {
      field: "ValueChgPercent", headerName: "Value Change %", cellStyle: { textAlign: 'right' },
      valueFormatter: percentageFormatter,
      cellStyle: colorCellStyle,
    },
    {
      field: "PortWeight", headerName: "% of Portfolio", cellStyle: { textAlign: 'right' },
      valueFormatter: percentageFormatter,
      cellStyle: colorCellStyle,
    },
    { field: "PortWeightChg", headerName: "Port Weight Chg", cellStyle: { textAlign: 'right' },
    valueFormatter: percentageFormatter,
    cellStyle: colorCellStyle,
   },
    {
      field: "ReportDate", headerName: "ReportDate", valueFormatter: (params) => {
        if (params.value != null) {
          const date = new Date(params.value);
          const formattedDate = `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`;
          return formattedDate;
        }
        else {
          return '';
        }
      }, minWidth:120
    },
    {
      field: "MktValueDate", headerName: "Market value date ", valueFormatter: (params) => {
        if (params.value != null) {
          const date = new Date(params.value);
          const formattedDate = `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`;
          return formattedDate;
        }
        else {
          return '';
        }
      },  minWidth:120
    },

  ];
  const defaultColDef = {
    sortable: true, filter: true ,flex:1  ,autoHeaderHeight: true,resizable:true
  };

    // Custom value formatter for number format
    function currencyFormatter(params) {
      if (params.value != null) {
        const formattedValue = parseFloat(params.value).toLocaleString(undefined, {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        });
        return formattedValue;
      } else {
        return '';
      }
    }

    function percentageFormatter(params) {
      if (params.value != null) {
        const formattedValue = `${parseFloat(params.value).toFixed(1)}%`;
        return formattedValue;
      }
      else {
        return '';
      }
    }
  
    // Custom cell style to apply color if value < 0
    function colorCellStyle(params) {
      const value = parseFloat(params.value);
      const cellStyle = { textAlign: 'right' };
      
      if (value < 0) {
        cellStyle.color = 'red';
      }
      
      return cellStyle;
    }
  
  return (
    <>
      <div id="HoldingDiv">
        {Loading ? <><LoadingScreen /></> : <>
          <div className="container-fluid">
          <div className="row flex-wrap">
          <div className="col-md-3">
            <label
              htmlFor="select-fund"
              className="mb-1 ms-2 fw-semibold fs-12"
            >
              Asset
            </label>
            <div>
              <AssetDropDown
                value={currentAsset}
                onChange={AssetDDChanged}
                data={AssetListDDL}
              />
            </div>
          </div>
          <div className="col-md-3">
                  <label
                   
                    className="mb-1 ms-2 fw-semibold fs-12"
                  >
                    Date Range
                  </label>
                  <div className="">
                    <SBDateRangePicker 
                      value={{
                       start: StartDate ? moment(StartDate).toDate() : new Date(),
                        end : StartDate ? moment(EndDate).toDate() : new Date(),
                      }}
                      onChange={handleDateChange}
                    />
                    
                    {/* <DateRangePicker
                    className="SbaDateRage text-dark"
                      placeholder="Select Date Range"
                      value={[
                        StartDate ? moment(StartDate).toDate() : new Date(),
                        StartDate ? moment(EndDate).toDate() : new Date(),
                      ]}
                      format="MM/dd/yyyy"
                      block
                      character=" - "
                      onChange={handleDateChange}
                    /> */}
                  </div>
                 </div>
                  <div className="col-md-3 Aggregation rbDivs">
                  <label
                    className="mb-1 ms-2 fw-semibold fs-12"
                  >
                    Aggregation
                  </label>
                 
                 <div  className="d-flex gap-3">
                  <input type="radio" name="Aggregation" defaultChecked /><label className="label ms-1">
                  Issuer
                                        </label>
                  <input type="radio" name="Aggregation" /><label className="label ms-1">Security</label>
                  </div>
                </div>
         
              
                <div className="col-md-3">
                  <label
                    className="mb-1 ms-2 fw-semibold fs-12"
                  >
                    Options
                  </label>
                  <div  className="d-flex gap-3">
                 <input type="radio" name="Options" defaultChecked /><label className="label ms-1">Included</label>
                 <input type="radio" name="Options" /><label className="label ms-1">Excluded</label>
                  </div>
                  </div>
               </div>
              <div>
                {/* connet for end of page  */}
              </div>
            {holdingDataISLoading ? <><LoadingScreen /></>:<><div>
              <div className="mainSection">
                <label className="darkLabel"><b>Total Portfolio:</b></label>
                <div className="SubMainSection">
                  <div> <label className="darkLabel">Market Value ($MM):</label><label className="darkLabel">{HoldingSummary.MarketValue && `$${HoldingSummary.MarketValue}`}</label></div>
                  <div> <label className="darkLabel">MTD Return:</label><label className="darkLabel">{HoldingSummary.MTDReturn && `$${HoldingSummary.MTDReturn}`}</label></div>
                  <div> <label className="darkLabel">Long ($MM) :($MM):</label><label className="darkLabel">{HoldingSummary.LongValue && `$${HoldingSummary.LongValue}`}</label></div>
                  <div> <label className="darkLabel">Gross ($MM) :</label><label className="darkLabel">{HoldingSummary.Grossvalue && `$${HoldingSummary.Grossvalue}`}</label></div>
                  <div> <label className="darkLabel">Net ($MM) :</label><label className="darkLabel">{HoldingSummary.NetValue && `$${HoldingSummary.NetValue}`}</label></div>
                  <div> <label className="darkLabel">No of Issuers:</label><label className="darkLabel">{HoldingSummary.NoOfIssuers && `${HoldingSummary.NoOfIssuers}`}</label></div>
                  <div> <label className="darkLabel">YTD Return:</label><label className="darkLabel">{HoldingSummary.YTDReturn && `$${HoldingSummary.YTDReturn}`}</label></div>
                  <div> <label className="darkLabel">Short ($MM) :</label><label className="darkLabel">{HoldingSummary.ShortValue && `$${HoldingSummary.ShortValue}`}</label></div>
                </div>
              </div>
            </div>
              <div className="d-flex gap-3" style={{ height: "50rem" }}>
                <div className="w-50">
                  <label className="darkLabel">
                    Top Long Holdings:
                  </label>
                  <div className="d-flex justify-content-end">
                    <button type="button" className="p-sm-btn mx-1" onClick={() => { exportToExcel(topLongHoldingGridRef, "TopLongHolding.xlsx") }}><img src={download} alt="" />Export</button>
                  </div>
                  <div className="ag-theme-alpine w-100" style={{height: "40rem" }}  >
                    <div style={{ height: "100%" }}>
                      <AgGridReact
                        suppressResizeObserver={true}
                        columnDefs={columnDefs}
                        rowData={topLongHoldingData}
                        defaultColDef={defaultColDef}
                        pagination={true}
                        paginationPageSize={10}
                        onGridReady={(params) => {
                          //params.api.sizeColumnsToFit();
                          //params.api.sizeColumnsToFit();
                          topLongHoldingGridRef.current = params.api;
                        }}
                      ></AgGridReact>
                    </div>
                  </div>
                </div>
                <div className="w-50">
                  <label className="darkLabel">
                    Top Short  Holdings:
                  </label>
                  <div className="d-flex justify-content-end">
                <button type="button" className="p-sm-btn mx-1"><img src={download} alt="" />Export</button>
              </div>
                  <div className="ag-theme-alpine w-100" style={{ width: '37vw', height: "40rem" }}>
                    <div style={{ height: "100%" }}>
                      <AgGridReact
                        columnDefs={columnDefs}
                        rowData={shortLongHoldingData}
                        defaultColDef={defaultColDef}
                        pagination={true}
                        paginationPageSize={10}
                      ></AgGridReact>
                    </div>
                  </div>
                  <div>
                  </div>
                </div>
              </div>
              <div>
              <div className="d-flex justify-content-end">
                <button type="button" className="p-sm-btn mx-1"  onClick={() => { exportToExcel(holdingGridRef, "Holdings.xlsx") }}><img src={download} alt="" />Export</button>
              </div>
                <div className="ag-theme-alpine" style={{  height: '700px' }}>
                  {/* <div className="gridHeader container-fluid InBulidGridIcons">
                    <button title="Export Excel" className="ExcelExportButton" onClick={() => { exportToExcel(holdingGridRef, "Holdings.xlsx") }}><span className="k-icon k-i-excel"></span></button>
                  </div> */}
                  <div style={{ height: "92%" }}>
                    <AgGridReact
                      columnDefs={columnDefs}
                      rowData={HoldingData}
                      defaultColDef={defaultColDef}
                      onGridReady={params => {
                        holdingGridRef.current = params.api;
                        //updateHoldingColumnDefs();
                        //gridApi.current.getColumnDefs();
                      }}
                    ></AgGridReact>
                  </div>
                </div>
              </div>
            </>}
          </div>
        </>
        }
      </div>
    </>
  )
}
